import { FieldRenderProps, Field } from 'react-final-form';
import React from 'react';
import { HelperText, HelperType } from '../HelperText';
import {
  RF_FORM_GROUP,
  RF_ERROR,
  RF_REQUIRED,
  RF_DISABLED,
  RF_ACTIVE,
} from '../classes';
import { RffFieldProps } from '../FieldProps';
import classNames from 'classnames';
import { FormGroup } from '@mc/react-core';
import { ClassNameProp } from '../types';
import { useTheme } from '../useTheme';

export const FormItem: React.FC<
  React.PropsWithChildren<
    RffFieldProps & ClassNameProp & { disabled?: boolean; required?: boolean }
  >
> = ({ name, children, className, disabled, required }) => {
  const { ns } = useTheme();
  return (
    <Field name={name}>
      {({ meta, input: { value } }: FieldRenderProps<any>) => {
        const cls = classNames(`${ns}-f-form-item`, RF_FORM_GROUP, className, {
          [RF_ERROR]: meta.touched && (meta.error || meta.submitError),
          [RF_ACTIVE]: !!value,
          [RF_DISABLED]: disabled,
          [RF_REQUIRED]: required,
        });

        let helperText = null;
        if (meta.touched) {
          if (meta.error || meta.submitError) {
            helperText = (
              <HelperText type={HelperType.ERROR}>
                {meta.error || meta.submitError}
              </HelperText>
            );
          } else if (meta.pristine && (meta.error || meta.submitError)) {
            // TODO warning
            helperText = (
              <HelperText type={HelperType.WARNING}>
                {meta.error || meta.submitError}
              </HelperText>
            );
          }

          // TODO meta.asyncValidating, meta.autofilled
        }

        return (
          <FormGroup className={cls}>
            {children}
            {helperText}
          </FormGroup>
        );
      }}
    </Field>
  );
};

FormItem.displayName = 'PlainFieldFormItem';
